import { connect } from 'react-redux'
import at from 'lodash/at'
import get from 'lodash/get'

import { loadHistoriesForPin } from '../../actions/histories'

import HistoryList from '../../components/histories/history-list'

function mapStateToProps (state, ownProps) {
  const pagination = get(state, `pagination.historiesByPin.${ownProps.pinId}`, {})
  var histories = at(state.pinHistories, pagination.ids || [])

  histories = histories.map(history => ({ ...history, user: state.users[history.user] }))

  return {
    histories,
    hasNextPage: pagination.nextPageUrl
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(loadHistoriesForPin(ownProps.pinId))

  return {
    onLoadNextPage () {
      dispatch(loadHistoriesForPin(ownProps.pinId, true))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HistoryList)



// WEBPACK FOOTER //
// ./src/containers/histories/history-list-container.js